/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import {
  IGetCredentialIssuedListProps,
  RevokeCredentialProps,
} from "./components";

const is = require("is_js");

const SERVICE_NAME = "ProvisionalPageService";
const log: any = LoggerModule.getInstance();

export type IIssuedCredentialPageSrvGetPageContentArgs =
  IGetCredentialIssuedListProps;

export class ProvisionalPageService {
  private static instance: ProvisionalPageService;
  private vapp: VApplication;
  private criteria: any;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): ProvisionalPageService {
    if (!ProvisionalPageService.instance) {
      ProvisionalPageService.instance = new ProvisionalPageService(props);
    }
    return ProvisionalPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = [...this.criteria, ...data];
  }

  public resetCriteria() {
    this.criteria = [];
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(
    args: IIssuedCredentialPageSrvGetPageContentArgs
  ) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.where) {
      this.setCriteria(args?.where);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getPolicyListsProps({
      ...args,
      where: [...args?.where, ...this.criteria],
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public getPolicyList(args:any){
    const agent = getAgent();
    return agent.getDownloadPolicyListsProps(args);
  }
}
